module.exports = __webpack_public_path__ + "41c0c86ce260524abec242694abd8cbf.pdf";